import { Injectable } from '@angular/core';
import { DEFAULT_DIALOG_PANEL_CONFIG, ERROR_CONFIG, SUCCESS_CONFIG } from '../constants/dialog.constants';
import { GenericDialogComponent } from '../components/generic-dialog/generic-dialog.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { GusDialogConfig } from '../models/dialog.models';
import { ComponentType } from '@angular/cdk/portal';

@Injectable()
export class DialogApi {
  constructor(private readonly dialog: MatDialog) {}

  openSuccessDialog(message: string = '', config: MatDialogConfig = {}): MatDialogRef<GenericDialogComponent> {
    return this.dialog.open(GenericDialogComponent, {
      ...this.mergeConfigs(config),
      data: { ...SUCCESS_CONFIG, body: message },
    });
  }

  openErrorDialog(data: GusDialogConfig = {}, config: MatDialogConfig = {}): MatDialogRef<GenericDialogComponent> {
    return this.dialog.open(GenericDialogComponent, {
      ...this.mergeConfigs(config),
      data: { ...ERROR_CONFIG, ...data },
    });
  }

  openGenericDialog(data: GusDialogConfig, config: MatDialogConfig = {}): MatDialogRef<GenericDialogComponent> {
    return this.dialog.open(GenericDialogComponent, { ...this.mergeConfigs(config), data });
  }

  openCustomDialog<T, D>(
    type: ComponentType<T>,
    data: GusDialogConfig<D> = {},
    config: MatDialogConfig = {}
  ): MatDialogRef<T> {
    return this.dialog.open(type, { data, ...this.mergeConfigs(config) });
  }

  private mergeConfigs(config: MatDialogConfig): MatDialogConfig {
    return { ...DEFAULT_DIALOG_PANEL_CONFIG, ...config };
  }
}
